export const APP = 'APP';
export const THEME = 'THEME';
export const MODULE = 'MODULE';